const routerView = {
  template: "<router-view></router-view>"
};
import pollutionInfo from "@/views/unusualEnterpriseAmount/pollutionInfo.vue";

export default [{
    path: "/dashboard",
    component: routerView,
    children: [{
        path: "/dashboard/index",
        component: () =>
          import("@/views/dashboard.vue")
      },
      { //数据看板，今日企业信息：生产设施状态，污防设施，点击的跳转
        path: "/dashboard/dashboardEnterpriseInfo",
        component: () =>
          import("@/views/DashboardEnterpriseInfo.vue")
      },
      { //数据看板，今日企业信息：生产设施状态，污防设施，点击的跳转
        path: "/dashboard/DashboardEnterpriseInfoA",
        component: () =>
          import("@/views/DashboardEnterpriseInfoA.vue")
      },
      { //数据看板，今日企业信息：生产设施状态，污防设施，点击的跳转
        path: "/dashboard/DashboardEnterpriseInfoB",
        component: () =>
          import("@/views/DashboardEnterpriseInfoB.vue")
      },
      { //测试子母路由的跳转实现，跳转至需要新增的一个页面
        path: "/dashboard/areaenCount",
        component: () =>
          import("@/views/areaenCount.vue")
      },
      { //数据看板，设备状态：从企业信息跳转
        path: "/dashboard/dashboardEnterpriseInfo/deviceState",
        component: () =>
          import("@/views/DashboardDeviceState.vue")
      },
      {
        path: "/dashboard/ZWExceptionQuery",
        component: () =>
          import("@/views/ZWExceptionQuery")
      },
      {
        path: "/dashboard/ZWExceptionQuery/details",
        component: () =>
          import("@/views/ZWExceptionQuery/details.vue")
      },
      {
        path: "/dashboard/transRate",
        component: () =>
          import("@/views/TranRateManager.vue")
      },
      {
        path: "/dashboard/monitor/detail",
        component: () =>
          import("@/views/enterpriseInfomation/enterpriseCase.vue")
      },
      {
        path: "/dashboard/basicSituation/detail",
        component: () =>
          import("@/views/enterpriseInfomation/enterpriseCase.vue")
      },
      {
        path: "/dashboard/basicSituation",
        component: () =>
          import("@/views/basicSituation.vue")
      },
      {
        path: "/dashboard/exceptionAlarmLastday",
        component: () =>
          import("@/views/exceptionInfo/exceptionAlarmLastday/exceptionAlarmLastday.vue")
      },
      {
        path: "/dashboard/monitor",
        component: () =>
          import("@/views/AnalysisAreaIndustry.vue")
      },
      {
        path: "/dashboard/control",
        component: () =>
          import("@/views/ControlAreaIndustry.vue")
      },
      {
        path: "/dashboard/exception",
        component: routerView,
        children: [{
            path: "/dashboard/exception/exceptionList",
            component: () =>
              import("@/views/exceptionInfo/exceptionList/exceptionList.vue")
          },
          {
            path: "/dashboard/exception/exceptionList/exceptionDeviceDetails",
            component: () =>
              import("@/views/exceptionInfo/exceptionList/exceptionDeviceDetails.vue")
          },
          {
            path: "/dashboard/exception/exceptionList/detail",
            component: () =>
              import("@/views/enterpriseInfomation/enterpriseCase.vue")
          },
          {
            path: "/dashboard/exception/exceptionListG/detail",
            component: () =>
              import("@/views/enterpriseInfomationG/enterpriseCase.vue")
          },
          {
            path: "/dashboard/exception/exceptionEnterpriseList",
            component: () =>
              import("@/views/exceptionInfo/exceptionEnterpriseList/exceptionEnterpriseList.vue")
          },
          {
            path: "/dashboard/exception/exceptionEnterpriseList/detail",
            component: () =>
              import("@/views/enterpriseInfomation/enterprise/EnterpriseDeclareDetail.vue")
          },
          {
            path: "/dashboard/exception/exceptionAlarmInfo",
            component: () =>
              import("@/views/exceptionInfo/exceptionAlarmInfo/exceptionAlarmInfo.vue")
          },
          {
            path: "/dashboard/exception/exceptionAlarmInfo/twodays",
            component: () =>
              import("@/views/exceptionInfo/exceptionAlarmLastday/exceptionAlarmLastday.vue")
          }
        ]
      },
      {
        path: "/dashboard/monitorAnalysis",
        component: routerView,
        children: [{
            path: "/dashboard/monitorAnalysis/enterpriseAmount",
            component: routerView,
            children: [{
                path: "/dashboard/monitorAnalysis/enterpriseAmountList",
                component: () =>
                  import("@/views/enterpriseAmount")
              },
              {
                path: "/dashboard/monitorAnalysis/enterpriseEletricity",
                component: () =>
                  import("@/views/enterpriseAmount/details.vue")
              },
              {
                path: "/dashboard/monitorAnalysis/enterpriseEletricityDetails",
                component: () =>
                  import("@/views/enterpriseAmount/enterpriseEletricityDetails.vue")
              }
            ]
          },
          {
            path: "/dashboard/monitorAnalysis/unusualEnterpriseAmount",
            component: routerView,
            children: [{
                path: "/dashboard/monitorAnalysis/unusualEnterpriseAmountList",
                component: () =>
                  import("@/views/unusualEnterpriseAmount")
              },
              {
                path: "/dashboard/monitorAnalysis/enterpriseName",
                component: () =>
                  import("@/views/unusualEnterpriseAmount/details.vue")
              },
              {
                path: "/dashboard/monitorAnalysis/producePollution",
                component: pollutionInfo,
                children: [{
                    path: "/dashboard/monitorAnalysis/producePollution",
                    component: () =>
                      import("@/views/unusualEnterpriseAmount/producePollution.vue")
                  },
                  {
                    path: "/dashboard/monitorAnalysis/handlePollution",
                    component: () =>
                      import("@/views/unusualEnterpriseAmount/handlePollution.vue")
                  }
                ]
              }
            ]
          },
          {
            path: "/dashboard/deviceRunning",
            component: () =>
              import("@/views/deviceRunning.vue")
          }
        ]
      },
      {
        path: "/dashboard/ControlEnterprise",
        component: routerView,
        children: [{
            path: "/dashboard/ControlEnterprise/list",
            component: () =>
              import("@/views/ControlAreaIndustry.vue")
          },
          {
            path: "/dashboard/ControlEnterprise/history",
            component: () =>
              import("@/views/ControlHistory.vue")
          },
          {
            path: "/dashboard/ControlEnterprise/areaCount",
            component: () =>
              import("@/views/ControlAreaCount.vue")
          },
          {
            path: "/dashboard/ControlEnterprise/count",
            component: () =>
              import("@/views/ControlIndustryCount.vue")
          },
          {
            path: "/dashboard/ControlEnterprise/count/detail",
            component: () =>
              import("@/views/enterpriseInfomation/enterpriseCase.vue")
          }
        ]
      },
      {
        path: "/dashboard/electricityConsumption",
        component: () =>
          import("@/views/dashboard/electricityConsumption/ElectricityConsumption.vue")
      }
    ]
  },
  {
    path: "/alarm",
    component: routerView,
    children: [{
        path: "/alarm/alarmList",
        component: () =>
          import("@/views/enterpriseAlarm")
      },
      {
        path: "/alarm/alarmList/governPollutionAlarm",
        component: () =>
          import("@/views/enterpriseAlarm/governPollutionAlarm")
      },
      {
        path: "/alarm/alarmStatistics",
        component: () =>
          import("@/views/enterpriseAlarm/alarmStatisticsIndex.vue")
      },
      {
        path: "/alarm/alarmList/governPollutionAlarm/details",
        component: () =>
          import("@/views/enterpriseAlarm/governPollutionAlarm/details.vue")
      },
      {
        path: "/alarm/alarmList/governPollutionAlarm/limitProduction",
        component: () =>
          import("@/views/enterpriseAlarm/governPollutionAlarm/limitProduction.vue")
      },
      {
        path: "/alarm/alarmList/governPollutionAlarm/hisMessage",
        component: () =>
          import("@/views/enterpriseAlarm/governPollutionAlarm/hisMessage.vue")
      },
      {
        path: "/alarm/alarmList/otherAlarm",
        component: () =>
          import("@/views/enterpriseAlarm/otherAlarm")
      },
      {
        path: "/alarm/alarmList/otherAlarm/details",
        component: () =>
          import("@/views/enterpriseAlarm/otherAlarm/details.vue")
      },
      {
        path: "/alarm/alarmList/nameList",
        component: () =>
          import("@/views/enterpriseAlarm/NameList.vue")
      },
      {
        path: "/alarm/alarmList/numList",
        component: () =>
          import("@/views/enterpriseAlarm/NumList.vue")
      },
      {
        path: "/alarm/alarmSetting",
        component: () =>
          import("@/views/enterpriseAlarmSetting.vue")
      },
      {
        path: "/alarm/alarmPush",
        component: () =>
          import("@/views/enterpriseAlarmPush.vue")
      },
      {
        path: "/alarm/alarmAnalysis",
        component: () =>
          import("@/views/enterpriseAlarmAnalysis.vue")
      },
      {
        //企业端路由-告警分析
        path: "/alarm/enAlarmList",
        component: () =>
          import("@/views/EnterpriseAlarmList.vue")
      },
      {
        //企业端路由-告警名称
        path: "/alarm/enAlarmList/nameList",
        component: () =>
          import("@/views/enterpriseAlarm/NameList.vue")
      },
      {
        //企业端路由-告警数量
        path: "/alarm/enAlarmList/numList",
        component: () =>
          import("@/views/enterpriseAlarm/NumList.vue")
      },
      {
        path: "/alarm/SmsPushSetting",
        component: () =>
          import("@/views/smsPushSetting.vue")
      }
    ]
  },
  {
    path: "/enterprise",
    component: routerView,
    children: [{
        path: "/enterprise/thoroughInvestige",
        component: () =>
          import("@/views/thoroughInvestige.vue")
      },
      {
        path: "/enterprise/thoroughInvestige/detail",
        component: () =>
          import("@/views/thorInvestDetail.vue")
      },
      {
        path: "/enterprise/locationInfo",
        component: () =>
          import("@/views/enterpriseLocationInfo.vue")
      },
      {
        path: "/enterprise/enterpriseList",
        component: () =>
          import("@/views/EnterpriseList.vue")
      },
      {
        path: "/enterprise/enterpriseListG",
        component: () =>
          import("@/views/EnterpriseListG.vue")
      },
      {
        path: "/enterprise/enterpriseList/detail",
        component: () =>
          import("@/views/enterpriseInfomation/enterpriseCase.vue")
      },
      {
        path: "/enterprise/enterpriseListG/detail",
        component: () =>
          import("@/views/enterpriseInfomationG/enterpriseCase.vue")
      },
      {
        path: "/enterprise/enterpriseList/detail/declare",
        component: () =>
          import("@/views/enterpriseInfomation/enterprise/EnterpriseDeclareDetail.vue")
      },
      {
        path: "/enterprise/enterpriseListG/detail/declare",
        component: () =>
          import("@/views/enterpriseInfomationG/enterprise/EnterpriseDeclareDetail.vue")
      },
      {
        path: "/enterprise/enterpriseList/history",
        component: () =>
          import("@/views/enterpriseInfomation/enterprise/EnterpriseLimitHistory.vue")
      },
      {
        path: "/enterprise/enterpriseListG/history",
        component: () =>
          import("@/views/enterpriseInfomationG/enterprise/EnterpriseLimitHistory.vue")
      },
      {
        path: "/enterprise/enterpriseList/detail/eledetail",
        component: () =>
          import("@/views/enterpriseInfomation/enterprise/EnterpriseEleDetail.vue")
      },
      {
        path: "/enterprise/enterpriseListG/detail/eledetail",
        component: () =>
          import("@/views/enterpriseInfomationG/enterprise/EnterpriseEleDetail.vue")
      },
      {
        path: "/enterprise/workshopCase",
        component: () =>
          import("@/views/enterpriseInfomation/workshop/workshop.vue")
      },
      {
        path: "/enterprise/workshopCase/eleDetail",
        component: () =>
          import("@/views/enterpriseInfomation/workshop/WorkshopEleDetail.vue")
      },
      {
        path: "/enterprise/pollutionGovernPoint",
        component: () =>
          import("@/views/enterpriseInfomation/pollutionGovernPoint")
      },
      {
        path: "/enterprise/enterpriseDevice",
        component: routerView,
        children: [{
            path: "/enterprise/enterpriseDevice/producePollutionDevice",
            component: () =>
              import("@/views/enterpriseInfomation/enterpriseDevice/producePollutionDevice")
          },
          {
            path: "/enterprise/enterpriseDevice/producePollutionDevice/detail",
            component: () =>
              import(
                "@/views/enterpriseInfomation/enterpriseDevice/producePollutionDevice/enterpriseEletricityDetail.vue"
              )
          }
        ]
      },
      {
        path: "/enterprise/enterpriseDeviceG/producePollutionDevice/detail",
        component: () =>
          import(
            "@/views/enterpriseInfomationG/enterpriseDevice/producePollutionDevice/enterpriseEletricityDetail.vue"
          )
      },
      {
        path: "/enterprise/handlePollutionDevice",
        component: () =>
          import("@/views/enterpriseInfomation/enterpriseDevice/handlePollutionDevice")
      },
      {
        //企业端路由-企业档案
        path: "/enterprise/enenterpriseList",
        component: () =>
          import("@/views/EnterpriseInfo.vue")
      },
      {
        path: "/enterprise/areaenCount",
        component: () =>
          import("@/views/areaenCount.vue")
      }
    ]
  },
  {
    path: "/analysis",
    component: routerView,
    children: [{
        path: "/analysis/analysisAreaIndustry",
        component: () =>
          import("@/views/AnalysisAreaIndustry.vue")
      },
      {
        path: "/analysis/analysisCutEmissions",
        component: () =>
          import("@/views/analysisCutEmissions")
      },
      {
        path: "/analysis/analysisCutEmissions/details",
        component: () =>
          import("@/views/analysisCutEmissions/details.vue")
      },
      {
        path: "/analysis/electricityUsageComparison",
        component: () =>
          import("@/views/dataAnalysis/electricityUsageComparison")
      },
      {
        path: "/analysis/statisticsAbnormal",
        component: () =>
          import("@/views/StatisticsAbnormal/abnormalEnterprise.vue")
      },
      {
        path: "/analysis/statisticsAbnormal/alarmTime",
        component: () =>
          import("@/views/StatisticsAbnormal/alarmTime.vue")
      },
      {
        path: "/analysis/statisticsAbnormal/alarmTime/details",
        component: () =>
          import("@/views/enterpriseInfomation/enterpriseCase.vue")
      },
      {
        path: "/analysis/analysisLimit",
        component: () =>
          import("@/views/ControlAreaIndustry.vue")
      },
      {
        path: "/analysis/analysisLimit/area",
        component: () =>
          import("@/views/ControlAreaCount.vue")
      },
      {
        path: "/analysis/analysisLimit/industry",
        component: () =>
          import("@/views/ControlIndustryCount.vue")
      },
      {
        //数据分析-区域分析-正常企业数量
        path: "/analysis/analysisAreaIndustry/normal",
        component: () =>
          import("@/views/AnalysisAreaNormalList.vue")
      },
      {
        //数据分析-
        path: "/analysis/areaElectricity",
        component: () =>
          import("@/views/areaElectricity.vue")
      },
      {
        //数据分析-区域分析- 企业案例
        path: "/analysis/analysisAreaIndustry/normal/detail",
        component: () =>
          import("@/views/enterpriseInfomation/enterpriseCase.vue")
      },
      {
        //数据分析 - 限产企业分析 - 企业案例
        path: "/analysis/analysisLimit/area/detail",
        component: () =>
          import("@/views/enterpriseInfomation/enterpriseCase.vue")
      },
      {
        path: "/analysis/enterpriseEletricityTable",
        component: () =>
          import("@/views/enterpriseEletricityTable")
      },
      {
        path: "/analysis/analysisReport",
        component: () =>
          import("@/views/AnalysisReport.vue")
      }
    ]
  },
  {
    path: "/declare",
    component: routerView,
    children: [{
        path: "/declare/setting",
        component: () =>
          import("@/views/declare/DeclareSetting.vue")
      },
      {
        path: "/declare/detail",
        component: () =>
          import("@/views/declare/DeclareDetail.vue")
      },
      {
        path: "/declare/declareCompany",
        component: () =>
          import("@/views/declare/declareCompany.vue")
      },
      // {
      //   path: "/declare/newEvent",
      //   component: () =>
      //   import("@/views/declare/eventArchive/newEvent.vue")
      // },
      {
        path: "/declare/eventArchiving",
        component: () =>
          import("@/views/declare//eventArchive/index.vue"),
      },
      
      {
        path: "/declare/troubleProcess",
        component: () =>
          import("@/views/declare/question/list"),
        children: [{
          path: "/declare/troubleProcess/detail",
          component: () =>
            import("@/views/declare/question/detail.vue")
        },
      ]},
      {
        path: "/declare/eventArchive",
        component: () =>
          import("@/views/declare/eventArchive/index.vue")
      },
      {
        path: "/declare/newEvent",
        component: () =>
          import("@/views/declare/eventArchive/newEvent.vue")
      },
      {
        path: "/declare/oddDeclareDetails",
        component: () =>
          import("@/views/declare/OddDeclareDetails.vue")
      },
    ]
  },
  {
    path: "/plan",
    component: routerView,
    children: [{
        path: "/plan/planList",
        component: () =>
          import("@/views/plan/list/list.vue")
      },
      {
        path: "/plan/formPlan",
        component: () =>
          import("@/views/plan/formplan/FormPlan.vue")
      },
      {
        path: "/plan/newPlan",
        component: () =>
          import("@/views/plan/newplan/NewPlan.vue")
      },
      {
        path: "/plan/planEdit",
        component: () =>
          import("@/views/plan/planEdit/list.vue")
      },
      {
        path: "/plan/planEdit2",
        component: () =>
          import("@/views/plan/planEdit2/list.vue")
      },
      {
        path: "/plan/switchPlan",
        component: () =>
          import("@/views/plan/planEdit2/SwitchPlan.vue")
      },
      {
        path: "/plan/doPlan",
        component: () =>
          import("@/views/plan/doplan/DoPlan.vue")
      },
      {
        path: "/plan/planSetting",
        component: () =>
          import("@/views/plan/planSetting/PlanSetting.vue")
      },
      {
        path: "/plan/planSettingPower",
        component: () =>
          import("@/views/plan/planSetting/PlanSettingPower.vue")
      },
      {
        path: "/plan/groupSetting",
        component: () =>
          import("@/views/plan/planSetting/GroupSetting.vue")
      },
      {
        path: "/plan/planSearch",
        component: () =>
          import("@/views/plan/planSearch/PlanSearch.vue")
      },
      {
        path: "/plan/calendarControl",
        component: () =>
          import("@/views/plan/calendarControl/calendarControl.vue")
      },
      {
        path: "/plan/calendarControlFromDashboard",
        component: () =>
          import("@/views/plan/calendarControl/calendarControl.vue")
      },
      {
        path: "/plan/changePlan",
        component: () =>
          import("@/views/plan/switchPlan/list.vue")
      },
      {
        path: "/plan/proManage",
        component: () =>
          import("@/views/plan/proManage/proManage.vue")
      }
    ]
  },
  {
    path: "/device",
    component: routerView,
    children: [{
        path: "/device/pollution",
        component: () =>
          import("@/views/PollutionDevice.vue")
      },
      {
        path: "/device/InstallLedger",
        component: () =>
          import("@/views/InstallLedger.vue")
      },
      {
        path: "/device/simcardmanage",
        component: () =>
          import("@/views/devicemanage/simcardmanage/list.vue")
      },
      {
        path: "/device/breakpointexport",
        component: () =>
          import("@/views/devicemanage/breakpointexport/index.vue")
      },
      {
        path: "/device/monitorProducts",
        component: () =>
          import("@/views/devicemanage/monitorProduct.vue")
      }
    ]
  },
  {
    path: "/system",
    component: routerView,
    children: [{
        path: "/system/surveyUser",
        component: () =>
          import("@/views/systemSetting/userContorller/SurveyPage.vue")
      },
      {
        path: "/system/user",
        component: () =>
          import("@/views/systemSetting/userContorller/UserPage.vue")
      },
      {
        path: "/system/enAccountManage",
        component: () =>
          import("@/views/systemSetting/userContorller/EnterPrisePage1.vue")
      },
      {
        path: "/system/govAccountManage",
        component: () =>
          import("@/views/systemSetting/userContorller/GovPage1.vue")
      },
      {
        path: "/system/usageAnalysis",
        component: () =>
          import("@/views/usageAnalysis.vue")
      },
      {
        path: "/system/role",
        component: () =>
          import("@/views/systemSetting/roleContorller/rolePage.vue")
      },
      {
        path: "/system/menuPage",
        component: () =>
          import("@/views/NewMenuPage.vue")
      },
      {
        path: "/system/org",
        component: () =>
          import("@/views/Organization.vue")
      },
      {
        path: "/system/organization",
        component: () =>
          import("@/views/OrgManage1.vue")
      },
      {
        path: "/system/enterpriseManage",
        component: () =>
          import("@/views/EnterpriseManager1.vue")
      },
      {
        path: "/system/enterpriseManage/deviceTree",
        component: () =>
          import("@/views/DeviceTreeManage.vue")
      },
      {
        path: "/system/enterpriseManage/cardmanage",
        component: () =>
          import("@/views/systemSetting/cardmanage/list.vue")
      },
      {
        path: "/system/enterpriseManage/deviceTree/group",
        component: () =>
          import("@/views/DeviceTreeManageGroup.vue")
      },
      {
        path: "/system/enterpriseManage/deviceTree/group1",
        component: () =>
          import("@/views/DeviceTreeManageGroup1.vue")
      },
      
      {
        path: "/system/enterpriseManage/contact",
        component: () =>
          import("@/views/ContactManager.vue")
      },
      {
        path: "/system/enterpriseManage/monitor",
        component: () =>
          import("@/views/MonitorManager.vue")
      },
      {
        path: "/system/enterpriseManage/monitor/add",
        component: () =>
          import("@/views/AddMonitor.vue")
      },
      {
        path: "/system/ProductRelationMatch",
        component: () =>
          import("@/views/ProductionRelationsMatch.vue")
      },
      {
        path: "/system/ProductRelationMatch/ProductRelation",
        component: () =>
          import("@/views/ProductionRelations.vue")
      },
      {
        //企业端路由-企业信息管理
        path: "/system/enEnterpriseManager",
        component: () =>
          import("@/views/EnterpriseEditPage.vue")
      },
      {
        //企业端路由-企业信息管理-联系人管理
        path: "/system/enEnterpriseManager/contact",
        component: () =>
          import("@/views/ContactManager.vue")
      },
      {
        //企业端路由-企业信息管理-设备管理
        path: "/system/enEnterpriseManager/deviceTree",
        component: () =>
          import("@/views/DeviceTreeManage.vue")
      },
      {
        //企业端路由-企业信息管理-配置管理
        path: "/system/enEnterpriseManager/monitor",
        component: () =>
          import("@/views/MonitorManager.vue")
      },
      {
        //企业端路由-企业信息管理-设备管理-分组管理
        path: "/system/enEnterpriseManager/deviceTree/group",
        component: () =>
          import("@/views/DeviceTreeManageGroup.vue")
      },
      {
        //企业端路由-企业信息管理-设备管理-分组管理
        path: "/system/enEnterpriseManager/deviceTree/group1",
        component: () =>
          import("@/views/DeviceTreeManageGroup1.vue")
      },
      {
        path: "/system/eleReview",
        component: () =>
          import("@/views/systemSetting/registerReview/Company.vue")
      },
      {
        path: "/system/govReview",
        component: () =>
          import("@/views/systemSetting/registerReview/gov.vue")
      },
      {
        path: "/system/othersReview",
        component: () =>
          import("@/views/systemSetting/registerReview/Operator.vue")
      },
      {
        //第三方数据来源端路由-运维单位信息维护
        path: "/system/othersMsg",
        component: () =>
          import("@/views/OthersUnitInfoManage.vue")
      }
    ]
  },
  {
    path: "/tool",
    component: routerView,
    children: [{
        path: "/tool/dbtool",
        component: () =>
          import("@/views/tool/tool.vue")
      },
      {
        path: "/tool/ctool",
        component: () =>
          import("@/views/tool/ctool.vue")
      }
    ]
  },
  {
    path: "/device",
    component: routerView,
    children: [{
      path: "/device/deviceManage",
      component: () =>
        import("@/views/DeviceManage.vue")
    }]
  },
  {
    //企业端路由-监控分析
    path: "/monitor",
    component: routerView,
    children: [{
      //企业端路由-监控分析-监控分析
      path: "/monitor/caseDetail",
      component: () =>
        import("@/views/enterpriseInfomation/enterpriseCaseEn.vue")
    }]
  },
  {
    path: "/en_declare",
    component: routerView,
    children: [{
        path: "/en_declare/index",
        component: () =>
          import("@/views/en_declareEnterprise.vue")
      },
      {
        path: "/en_declare/add",
        component: () =>
          import("@/views/en_addDeclare.vue")
      },
      {
        path: "/en_declare/detail",
        component: () =>
          import("@/views/en_declareDetail.vue")
      }
    ]
  },
  {
    path: "/ExplorationAssistant",
    component: routerView,
    children: [{
        path: "/ExplorationAssistant/spotChecking",
        component: () =>
          import("@/views/SurveyEnterprise.vue")
      },
      {
        path: "/ExplorationAssistant/map",
        component: () =>
          import("@/views/Map.vue")
      },
      {
        path: "/ExplorationAssistant/spotChecking/addPolluter",
        component: () =>
          import("@/views/ExplorationAssistant/AddPolluter.vue")
      },
      {
        path: "/ExplorationAssistant/spotChecking/deviceManage",
        component: () =>
          import("@/views/ExplorationAssistant/DeviceManage.vue")
      },
      {
        path: "/ExplorationAssistant/spotChecking/contact",
        component: () =>
          import("@/views/SurveyContact.vue")
      },
      {
        path: "/ExplorationAssistant/spotChecking/equipment",
        component: () =>
          import("@/views/deviceManagement/equipment.vue")
      },
      {
        path: "/ExplorationAssistant/spotChecking/steps/backupRelation",
        component: () =>
          import("@/views/ExplorationAssistant/backupRelation.vue")
      },
      {
        path: "/ExplorationAssistant/spotChecking/equipment/group2",
        component: () =>
          import("@/views/deviceManagement/deviceTree/DeviceTreeManageGroup.vue")
      },
      {
        path: "/ExplorationAssistant/spotChecking/equipment/group3",
        component: () =>
          import("@/views/deviceManagement/deviceTree/DeviceTreeManageGroup1.vue")
      },
    ]
  },
  {
    //企业端路由-数据看板
    path: "/en_dashboard",
    component: routerView,
    children: [{
        //企业端路由-数据看板-数据看板
        path: "/en_dashboard/index",
        component: () =>
          import("@/views/en_dashboard.vue")
      },
      {
        path: "/en_dashboard/produceDevice",
        component: () =>
          import("@/views/en_produceDevice.vue")
      },
      {
        path: "/en_dashboard/pollutionAlarm",
        component: () =>
          import("@/views/en_pollutionAlarm.vue")
      },
      {
        path: "/en_dashboard/abnormalControl",
        component: () =>
          import("@/views/en_abnormalControl.vue")
      }
    ]
  },
  {
    path: "/bigScreen",
    component: routerView,
    children: [{
        path: "/bigScreen/index",
        component: () =>
          import("@/views/bigScreen.vue")
      }, {
        path: "/bigScreen/list",
        component: () =>
          import("@/views/bigScreenEditor/bigScreenList.vue")
      }, {
        path: "/bigScreen/editor",
        component: () =>
          import("@/views/bigScreenEditor/bigScreenEditor.vue")
      },
      {
        path: "/monitor/chanxiantu",
        component: () =>
          import("@/views/bigScreenEditor/bigScreenView.vue")
      }, {
        path: "/bigScreen/view",
        component: () =>
          import("@/views/bigScreenEditor/bigScreenView.vue")
      }, {
        path: "/bigScreen/map",
        component: () =>
          import("@/views/bigScreenMap/bigScreenMapB.vue")
      },
      {
        path: "/plan/chanxianlist",
        component: () =>
          import("@/views/bigScreenEditor/bigScreenListZF.vue")
      },
    ]
  },
];



// WEBPACK FOOTER //
// ./src/router/routerMap.js